/*
 *
 * KitStartCard
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 17-Mar-2025
*/

import React from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import MerchantTableBadge from '@nexidigital/merchanttablebadge'
import formattedMessage from '../languageModule.jsx'
import './KitStartCard.scss'

const KitStartCard = ({ title, description, img, altTextImg, service, languageModule }) => {
  // Determina se mostrare il badge e quale testo usare
  // Se non c'è service, mostra sempre il badge "Gratuito" (retrocompatibilità)
  // Se c'è service ma nessun freeMonths, mostra "Gratuito"
  // Se c'è freeMonths, mostra "Gratis per X mesi"
  const shouldShowBadge = true // I badge si mostrano sempre

  // Usa sempre formattedMessage come fallback se languageModule è null/undefined
  const activeLanguageModule = languageModule || formattedMessage

  const getBadgeLabel = () => {
    // Se non c'è servizio (retrocompatibilità) o non ha freeMonths, usa "Gratuito"
    if (!service?.additionalData?.freeMonths) {
      return activeLanguageModule.servicesFreeLabel
    }

    // Se ha freeMonths, usa il testo dinamico
    const freeMonths = service.additionalData.freeMonths
    return activeLanguageModule.getFreeBadgeLabel(freeMonths)
  }

  return (
    <Toggle>
      <div className='kitStartCard'>
        <div className='kitStartCardImg'>
          <img src={img} alt={altTextImg} />
          {shouldShowBadge && (
            <div className='kitStartCardBadge'>
              <MerchantTableBadge symbol label={getBadgeLabel()} status='success' />
            </div>
          )}
        </div>
        <div className='kitStartCardText'>
          <h1 className='kitStartCardTitle'>{title}</h1>
          <p className='kitStardCardDescription'>{description}</p>
        </div>
      </div>
    </Toggle>
  )
}

KitStartCard.propTypes = {
  // Add here some propTypes
  // and set a minimal description i.e.
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  altTextImg: PropTypes.string.isRequired,
  service: PropTypes.object, // Dati del servizio per determinare badge
  languageModule: PropTypes.object // LanguageModule per supportare diversi contesti
}

KitStartCard.defaultProps = {
  // Add here some default propTypes values
  title: '',
  description: '',
  img: '',
  altTextImg: '',
  service: null,
  languageModule: undefined // undefined permette al fallback di funzionare
}

export default KitStartCard
